import {getAssetPath} from "../../../../../../utils/get-asset-path.js";

const ModalHeader = ({ code, capturePlaceDescription, routeDescription, routeRegionType, laneDescription }) => {
  if (!capturePlaceDescription && !routeDescription && !routeRegionType) {
    return <span>Nova câmera</span>;
  }

  return (
    <div className="flex items-center justify-start gap-2">
      {routeRegionType && (
        <div className="flex items-center h-[24px]">
          <img
            src={getAssetPath(`/img/sentry_lane/${routeRegionType}.png`)}
            alt={routeRegionType}
          />
        </div>
      )}
      <span id="">
        {capturePlaceDescription || ""}
        {routeDescription ? ` (${code ? `${code} - ` : ""} ${routeDescription}${laneDescription ? `: ${laneDescription}` : ""})` : ""}
      </span>
    </div>
  );
};

export default ModalHeader;